import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input", "loadingCircle", "uploadButton"]

  submit() {
    if (this.inputTarget.files?.length) {
      this.formTarget.requestSubmit()
      this.loadingCircleTarget.classList.remove("hidden")
      this.uploadButtonTarget.classList.add("hidden")
    }
  }
}
